import { useState, useEffect } from "react";
import BaseAppLayout from "../../layouts/BaseAppLayout/BaseAppLayout";
import { Toaster } from "react-hot-toast";
import ApiManager from "../../api/ApiManager";
import { useAuth } from "../../store/AuthContext/AuthContext";
import RoadmapComponent from "./RoadmapComponent";

export default function Roadmap() {
  const [roadmapId, setRoadmapId] = useState(null);
  const [hasIndex, setHasIndex] = useState(false);
  const [loading, setLoading] = useState(true);
  const [aiResponse, setAiResponse] = useState(null);

  const { getCookie } = useAuth();
  const projectId = getCookie("project_id");
  const user_sub = getCookie("auth_token");
  const id_token = getCookie("id_token");
  const api = new ApiManager();

  // Initial load - check eligibility and get existing index
  useEffect(() => {
    checkEligibility();
  }, []);

  const checkEligibility = () => {
    setLoading(true);
    api
      .get(`/roadmap/eligible?project_id=${projectId}`, {
        headers: { Authorization: `Bearer ${id_token}` },
      })
      .then((response) => {
        // Verifica se è presente una roadmap ID e salva il primo trovato
        if (
          response.data.roadmap &&
          Array.isArray(response.data.roadmap.roadmap) &&
          response.data.roadmap.roadmap.length > 0
        ) {
          setRoadmapId(response.data.roadmap_id);
        }

        // Salva lo stato di eligibilità (true o false)
        setHasIndex(Boolean(response.data.eligible));

        // Controlla se la roadmap è presente e se contiene dati
        if (response.data.roadmap) {
          // Caso in cui la roadmap sia un array di oggetti
          if (
            Array.isArray(response.data.roadmap) &&
            response.data.roadmap.length > 0
          ) {
            // Cerca il primo oggetto valido nella roadmap
            const validRoadmap = response.data.roadmap.find(
              (item) => item && item.ai_response
            );
            if (validRoadmap && validRoadmap.ai_response) {
              try {
                const jsonRoadmap = JSON.parse(validRoadmap.ai_response);
                setAiResponse(jsonRoadmap.content || jsonRoadmap);
              } catch (e) {
                setAiResponse(validRoadmap.ai_response);
              }
            } else {
              setAiResponse(validRoadmap);
            }
          }
          // Caso in cui la roadmap è un oggetto singolo
          else if (typeof response.data.roadmap === "object") {
            setAiResponse(response.data.roadmap);
          }
        }
        // Caso in cui la roadmap non è un array o oggetto, ma solo una risposta ai (ai_response)
        else if (response.data.ai_response) {
          setAiResponse(response.data.ai_response);
        }

        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        setHasIndex(false);
      });
  };

  const handleGenerateRoadmap = async (formData) => {
    setLoading(true);

    // Map the selected indexes to the actual text values
    const frequenzaOptions = [
      "Sempre sui Libri",
      "Quasi Sempre",
      "A giorni alterni",
      "Quando capita",
    ];
    const oreOptions = [
      "Full immersion",
      "Studio solido",
      "Un pò alla volta",
      "Il minimo sindacale",
    ];
    const goalOptions = [
      "Trovare le fonti",
      "Scrivere bene",
      "Organizzare il tutto",
      "Revisioni infinite",
    ];

    const media_settimana = frequenzaOptions[formData.selectedFrequenzaStudio];
    const media_ore = oreOptions[formData.selectedOreStudio];
    const goal_studio = goalOptions[formData.selectedDifficolta];
    const today = new Date().toISOString().split("T")[0];

    const payload = {
      project_id: projectId,
      indice_tesi: "Introduzione, Capitolo 1, Capitolo 2, Conclusioni",
      frequenza_studio: media_settimana,
      ore_studio: media_ore,
      sfida_principale: goal_studio,
      data_inizio: today,
      data_consegna: formData.selectedDate,
    };

    try {
      const response = await api.post("/roadmap/create", payload, {
        headers: { Authorization: `Bearer ${getCookie("id_token")}` },
      });

      // Extract the execution ARN from the response
      const executionArn = response.data.executionArn;

      // Start polling for status
      pollExecutionStatus(executionArn);
    } catch (error) {
      setLoading(false);
    }
  };

  // Function to poll for execution status
  const pollExecutionStatus = (executionArn) => {
    const checkStatus = async () => {
      try {
        const statusResponse = await api.get(
          `/roadmap/status?executionArn=${executionArn}`,
          { headers: { Authorization: `Bearer ${id_token}` } }
        );

        if (statusResponse.data.status === "SUCCEEDED") {
          // Parse the output JSON
          const outputData = statusResponse.data.output;

          // Update state with the roadmap data
          if (outputData.roadmap_id) {
            setRoadmapId(outputData.roadmap_id);
          }

          setAiResponse(outputData.roadmap);
          setHasIndex(true);
          setLoading(false);

          // Clear polling interval
          clearInterval(pollingInterval);
        } else if (statusResponse.data.status === "FAILED") {
          console.error("Roadmap generation failed:", statusResponse.data);
          setLoading(false);
          clearInterval(pollingInterval);
        }
        // If RUNNING, continue polling
      } catch (error) {
        console.error("Error checking roadmap status:", error);
        setLoading(false);
        clearInterval(pollingInterval);
      }
    };

    // Check immediately once
    checkStatus();

    // Then set up polling every 3 seconds
    const pollingInterval = setInterval(checkStatus, 3000);
  };

  const handleGenerateNuovo = () => {
    setAiResponse(null);
    setLoading(false);
  };

  return (
    <BaseAppLayout headerText="Roadmap">
      <Toaster />

      <RoadmapComponent
        hasIndex={hasIndex}
        loading={loading}
        aiResponse={aiResponse}
        setAiResponse={setAiResponse}
        handleGenerateRoadmap={handleGenerateRoadmap}
        handleGenerateNuovo={handleGenerateNuovo}
        checkEligibility={checkEligibility}
        projectId={projectId}
        user_sub={user_sub}
        getCookie={getCookie}
        api={api}
        roadmapId={roadmapId}
      />
    </BaseAppLayout>
  );
}
